module.exports = __webpack_public_path__ + "img/education.f7c882a3.svg";